import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class KijijiDailyBudgets extends Component {
  render() {
    return (
      <EntityList apiRoute='api/kijijidailybudgets' title='Budgets journalier Kijiji' editTitle='Budget journalier Kijiji' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Défaut', Column: 'Default'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default KijijiDailyBudgets;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/kijijiDailyBudgets.js
 **/